<template>
  <div>
    <el-row :gutter="20">
      <el-col class="" :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
        <div class="content_box">
          <div class="grid-content bg-purple">
            <el-breadcrumb separator="/">
              <!-- <el-breadcrumb-item :to="{ path: '/' }"
                >我的包裹</el-breadcrumb-item
              > -->
              <el-breadcrumb-item
                ><a @click="$router.back(-1)"
                  >{{ title }}</a
                ></el-breadcrumb-item
              >
              <el-breadcrumb-item>包裹详情</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="title_text">包裹详情</div>
          <div class="titile_box_uio">
            <div>
              <div class="title_text_two">运单号：{{ order.ordernumber }}</div>
              <div class="title_text_three" v-if="order.batchGroupType == 40 && order.batchname">
                所属批次：{{ order.batchname }}
              </div>
            </div>
            <div class="title_text_bosx">
              <div class="title_text_two">{{ title }}</div>
              <div class="title_text_lio">{{ order.route }}</div>
            </div>
          </div>
        </div>
        <div :class="costBox ? 'content_box' : 'content_box margin_bot'">
          <div class="content_box_title">
            <div class="circle_l"></div>
            <div class="circle_r"></div>
            <div class="text_xl">内件信息</div>
          </div>
          <div class="table_box" v-for="(item, index) in box" :key="index">
            <div class="table_box_title">
              <div>箱号{{index+1}}</div>
              <div class="table_box_title_right">
                <div>
                  尺寸：{{ item.length }}*{{ item.width }}*{{
                    item.height
                  }}（长*宽*高）
                </div>

                <div style="margin-left: 32px">实重：{{ item.weightkg }}</div>
              </div>
            </div>

            <el-table
              :header-cell-style="{ background: '#E7EDF8', color: '#333333' }"
              :data="item.itemVoList"
              stripe
              style="width: 100%"
            >
              <el-table-column align="center" prop="name" label="内件名称">
              </el-table-column>
              <el-table-column align="center" prop="brand" label="品牌">
              </el-table-column>
              <el-table-column
                align="center"
                prop="material"
                label="材质"
                v-if="order.isfromchina == 1"
              >
              </el-table-column>

              <el-table-column
                align="center"
                prop="claimprice"
                label="申报价值"
              >
              </el-table-column>
              <el-table-column align="center" prop="count" label="数量">
              </el-table-column>
              <el-table-column align="center" prop="category" label="种类">
                <!-- <template slot-scope="scope">
              <span>{{scope.row.category}}</span>
            </template> -->
              </el-table-column>
              <el-table-column
                align="center"
                v-if="order.isfromchina == 0"
                prop="format"
                label="规格"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="content_box">
          <div class="content_box_title" v-if="costBox">
            <div class="circle_l"></div>
            <div class="circle_r"></div>
            <div class="text_xl">重量及费用明细</div>
          </div>
          <div class="table_box" v-if="costBox">
            <el-row>
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  总重量
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ talWeightkg }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  运费
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.itemcost }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  超长费用
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.oversizecost }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  仓库费用
                </div></el-col
              >
              <el-col :span="4"
                ><div
                  class="grid-content bg-purple-light text_style border_right"
                >
                  {{ order.storagecost }}
                </div></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  总体积
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ talVolume.toFixed(2) }}kg
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  保险
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.insurance }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  熏蒸费用
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.fumigationcost }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  港杂费
                </div></el-col
              >
              <el-col :span="4"
                ><div
                  class="grid-content bg-purple-light text_style border_right"
                >
                  {{ order.portmiscost }}
                </div></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  箱数
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.baggagenum }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  实收关税
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.tax }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  地区附加费
                </div></el-col
              >
              <el-col :span="4"
                ><div class="grid-content bg-purple-light text_style">
                  {{ order.districtadditionalcost }}
                </div></el-col
              >
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style">
                  折扣
                </div></el-col
              >
              <el-col :span="4"
                ><div
                  class="grid-content bg-purple-light text_style border_right"
                >
                  {{ order.discount }}
                </div></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="2"
                ><div class="grid-content bg-purple text_style border_bottom">
                  总费用
                </div></el-col
              >
              <el-col :span="18"
                ><div class="grid-content bg-purple-light"></div
              ></el-col>
              <el-col :span="4"
                ><div
                  class="
                    grid-content
                    bg-purple-light
                    text_style
                    border_right border_bottom
                    color
                  "
                >
                  {{ order.shippingcost }}
                </div></el-col
              >
            </el-row>
          </div>
          <div
            class="weight_details_box"
            style="margin-top: 37px"
            v-if="costBox"
            @click="costBox = false"
          >
            <el-dropdown>
              <span class="el-dropdown-link">
                费用收起<i class="el-icon-arrow-up"></i>
              </span>
              <el-dropdown-menu></el-dropdown-menu>
            </el-dropdown>
          </div>
          <div
            class="weight_details_box"
            v-if="!costBox"
            @click="costBox = true"
          >
            <div>
              <div class="weight_details_text">
                <div class="weight_details_text_l">总重量</div>
                <div class="weight_details_text_r">{{ talWeightkg }}</div>
              </div>
              <div class="weight_details_text">
                <div class="weight_details_text_l">总体积</div>
                <div class="weight_details_text_r">{{ talVolume.toFixed(2) }}kg</div>
              </div>
              <div class="weight_details_text">
                <div class="weight_details_text_l">保险金额</div>
                <div class="weight_details_text_r">{{ order.insurance }}</div>
              </div>
              <div class="weight_details_text">
                <div class="weight_details_text_l font_wight">总费用</div>
                <div class="weight_details_text_r">
                  <div>
                    {{ order.shippingcost }}
                  </div>
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      费用详情<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                     <el-dropdown-menu></el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>

      <el-col class="" :xs="24" :sm="24" :md="24" :lg="9" :xl="9"
        ><div class="grid-content bg-purple-light">
          <div class="content_box">
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">运单信息</div>
            </div>
            <div class="right_box">
              <div>
                <div class="title_text_two">
                  国内单号：{{ order.domesticnumber }}
                </div>
                <div class="title_text_two">
                  国际单号：{{ order.secondtracknumber }}
                </div>
              </div>
              <div>
                <div class="title_text_two">
                  国内快递公司：{{ order.domesticcarrier }}
                </div>
                <div class="title_text_two">
                  国际快递公司：{{ order.secondcarrier }}
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">收件信息</div>
            </div>
            <div class="right_box" v-if="addressData != ''">
              <div>
                <div class="title_text_two">
                  {{ addressData.consignee }} {{ addressData.mobile }}
                </div>
                <div class="title_text_two">
                  {{ addressData.province }} {{ addressData.city }}
                  {{ addressData.district }} {{ addressData.detailArea }}
                </div>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">客户备注</div>
            </div>
            <div class="right_box">
              <div class="title_text_two">{{ order.memo }}</div>
            </div>
            <el-divider></el-divider>
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">运单包裹照片</div>
            </div>
            <div class="right_box" v-if="order.photourl">
              <div class="demo-image__preview">
                  
                <el-image
                
                  :src="order.photourl"
                  :preview-src-list="srcList"
                >
                </el-image>
              </div>
            </div>
            <el-divider></el-divider>
            <div class="content_box_title">
              <div class="circle_l"></div>
              <div class="circle_r"></div>
              <div class="text_xl">运单文件上传/下载</div>
            </div>
            <div  v-if="order.enclosure">{{enclosureNme}}</div>
            <div class="step_box_l">
              <el-upload
                :limit="1"
                class="upload_img"
                accept=".xlsx,.xls,.doc,.docx,.pdf,.txt"
                action="*"
                :show-file-list="false"
                :http-request="uploadHttpRequestss"
              >
                <div class="last_step" size="small" type="primary">
                  上传文件
                </div>
              </el-upload>
              <div
                v-if="order.enclosure"
                class="last_step_l"
                @click="enclosure"
              >
                下载文件
              </div>
            </div>
          </div>
        </div></el-col
      >
    </el-row>
  </div>
</template>
<script>
import crudDept from "@/api/userMG";
export default {
  data() {
    return {
      srcList:[],
      talWeightkg:0,
      enclosureNme:'',
      box: "",
      costBox: false,
      addressData: "",
      volume: "",
      money: "",
      order: "",
      title: "",
      tableData: [],
      talVolume:0,
      orderId: "",
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
    
    };
  },
  created() {
    this.orderId = this.$route.query.id;
    this.orderDetail(this.$route.query.id);
    this.boxList(this.$route.query.id);
    this.title = this.$route.query.name;
    
  },
  methods: {
    //上传文件
    uploadHttpRequestss(param) {
      var that = this;
      var credentials = {
        accessKeyId: "AKIAJEPDGNAK3LSG4D7Q",
        secretAccessKey: "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",
      };
      AWS.config.update(credentials);
      AWS.config.region = "us-east-1"; //设置区域
      var bucket = new AWS.S3({ params: { Bucket: "eplus-ex" } }); //选择桶
             var ksy = Number(new Date()) + Math.random().toString(36).substr(2);
      var params = {
        methods: "put",
        Body: param.file,
             Key: 'order/'+ksy+'/'+param.file.name,
        ContentType: param.file.type,
        "Access-Control-Allow-Credentials": "*",
        ACL: "public-read",
      };
      bucket.upload(params, function (err, data) {
        if (data) {
          that.order.enclosure = data.Location;
          that.updateOrder( data.Location)
        }
      });
    },
    updateOrder(enclosure) {
      var data={
        id:this.order.id,
        enclosure:enclosure

      }
      crudDept
        .updateOrder(data)
        .then((res) => {
          setTimeout(() => {
            that.loading = false;
            that.$message({
              message: "操作成功",
              type: "success",
            });
          }, 1500);
    this.orderDetail(this.$route.query.id);
     
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    enclosure() {
      window.location.href = this.order.enclosure;
    },
    //箱子
    boxList(id) {
      var data = {
        orderid: id,
      };
      crudDept.boxList(data).then((res) => {
        this.box = res.content;
        this.box.forEach(e => {
          this.talWeightkg+=e.weightkg*1;
          this.talVolume+=(e.height*1 *e.width*1*e.length*1)/5000;

        });
      });
    },
    //订单详情
    orderDetail(id) {
      var data = {
        orderId: id,
      };
      crudDept.orderDetail(data).then((res) => {
        this.order = res;
        this.volume = res.length * res.width * res.height;
          this.money =
          res.fumigationcost +
          res.portmiscost +
          res.storagecost +
          res.oversizecost +
          res.itemcost +
          res.insurance+res.districtadditionalcost+res.tax;
          this.srcList=[this.order.photourl];
          if(this.order.enclosure){

 this.enclosureNme=this.order.enclosure.split('/').slice(-1)[0];
          }

    
        this.address(res.recipientaddressid);
      });
    },
    address(id) {
      var data = {
        id: id,
      };
      crudDept.address(data).then((res) => {
        if( res.content != ''){
this.addressData = res.content[0];
        }
        
      });
    },
  },
};
</script>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #5178ff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.font_wight {
  font-weight: bold;
}
.weight_details_text_l {
  width: 100px;
  text-align: right;
  margin-right: 20px;
}
.weight_details_text_r {
  width: 150px;
  text-align: left;
  display: flex;
  justify-content: space-between;
}
.weight_details_text {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  margin-top: 20px;
  display: flex;
}
.weight_details_box {
  display: flex;
  justify-content: flex-end;
}
.title_text_bosx {
  text-align: center;
}
.title_text_lio {
  width: auto;
  height: 50px;
  background: #ecf0fc;
  opacity: 1;
  border-radius: 8px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 50px;
  padding: 0 15px;
  box-sizing: border-box;
  color: #5178ff;
  text-align: center;
  margin-top: 10px;
}
.titile_box_uio {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.step_box_l {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 87px;
}
.last_step {
  width: 150px;
  height: 44px;
  border: 1px solid #999999;
  box-shadow: 0px 3px 6px rgba(0, 102, 255, 0.16);
  opacity: 1;
  border-radius: 25px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  margin: 0 20px;
  line-height: 44px;
  text-align: center;
}
.last_step_l {
  width: 150px;
  height: 44px;
  background: #5178ff;
  box-shadow: 0px 3px 6px rgba(81, 120, 255, 0.1);
  opacity: 1;
  line-height: 44px;
  border-radius: 22px;
  margin: 0 20px;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  text-align: center;
  cursor: pointer;
}
.right_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.color {
  color: #ff7e33 !important;
}
.border_right {
  border-right: none !important;
}
.border_bottom {
  border-bottom: none !important;
}
.table_box .grid-content {
  min-height: 47px;
}
.text_style {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  border-right: 1px solid #e7edf6;
  border-bottom: 1px solid #e7edf6;
}
.table_box .bg-purple {
  background: #f1f5fc;
}
.bg-purple-light {
  background: transparent;
}
.el-table th,
.el-table tr {
  font-weight: normal !important;
}
.content_box_title {
  display: flex;
  align-items: center;

  margin-bottom: 26px;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.content_box_left {
}
.content_box {
  height: auto;
  background-color: #fff;
  padding: 38px 58px;
  margin-bottom: 12px;
  box-sizing: border-box;
}
.margin_bot {
  margin-bottom: 0 !important;
}
.title_text {
  font-size: 25px;
  font-family: PingFang SC;
  line-height: 36px;
  margin-top: 22px;
  color: #333333;
}
.title_text_two {
  font-size: 18px;
  font-family: PingFang SC;
  line-height: 25px;
  margin-top: 22px;
  color: #333333;
}
.title_text_three {
  font-size: 15px;
  line-height: 25px;
  margin-top: 22px;
  color: #333333;
}
.table_box {
  width: 100%;
  height: 100%;
  background: #ffffff;
  border: 1px solid #e7edf6;
  opacity: 1;
  border-radius: 10px;
  margin-bottom: 10px;
}
.table_box_title {
  display: flex;
  justify-content: space-between;
  padding: 16px 70px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #333333;
}
.table_box_title_right {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 20px;
  color: #333333;
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// src/views/parcel/parcelDetail.vue